import { render, staticRenderFns } from "./AdminSuperBono2View.vue?vue&type=template&id=cf55c2ec&"
import script from "./AdminSuperBono2View.vue?vue&type=script&lang=js&"
export * from "./AdminSuperBono2View.vue?vue&type=script&lang=js&"
import style0 from "./AdminSuperBono2View.vue?vue&type=style&index=0&id=cf55c2ec&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports